module.exports = __webpack_public_path__ + "fonts/icons.fbc3026.eot";